import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { UtilService } from './util.service';

@Injectable()
export class AnalyticsService {
	serviceConfigs = {
		appName: undefined,
		appVersion: undefined,
		GAKey: null,
		printGALogs: false //print ga logs
	};

	constructor(private utileService: UtilService,) {

		this.setConfigs({
			appName: environment.common.appName,
			appVersion: environment.common.appVersion,
			GAKey: environment.GAKey,
			printGALogs: environment.common.printGALogs //print ga logs
		});
		if (!this.utileService.isDevMode()) {
			this.initGA();
		}

	}

	setConfigs(configs) {
		Object.assign(this.serviceConfigs, configs);
	}

	initGA() {
		console.log(">>> starting Google Analytics!", this.serviceConfigs);

		if (!(this.serviceConfigs.GAKey)) {
			console.error("init GA fail! missing GA Key!");
			return false;
		}

		/*script from goolgle analytics api*/
		(function (i, s, o, g, r, a, m) {
			i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
				(i[r].q = i[r].q || []).push(arguments)
			}, i[r].l = 1 * <any>new Date(); a = s.createElement(o),
				m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
		})(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

		(<any>window).ga('create', {
			trackingId: this.serviceConfigs.GAKey,
			cookieDomain: 'auto'
		});

		(<any>window).ga('set', {
			appName: this.serviceConfigs.appName,
			appVersion: this.serviceConfigs.appVersion
		});

		(<any>window).ga('require', 'displayfeatures');//load ga displayfeatures plugin
	}

	log(...args: any[]) {//print to console
		if (this.serviceConfigs.printGALogs) {

			var argsArr = Array.prototype.slice.call(arguments)
			console.log(">>>(ga) ", argsArr);
		}
	}

	setView(moduleName, viewName) {
		var view = '/' + moduleName + '/' + viewName;
		var title = moduleName + ' | ' + viewName;
		this.log("setView:", view);

		(<any>window).ga('set', {
			page: view,
			title: title
		});
	}

	/* track page or view */
	trackView(moduleName, viewName?, subViewName?) {
		var view = moduleName + ((viewName) ? "/" + viewName : "") + ((subViewName) ? " - " + subViewName : "");
		var title = moduleName + ((viewName) ? ' | ' + viewName : "") + ((subViewName) ? " - " + subViewName : "");
		console.log(`%cGA FireBase trackView%c`, this.utileService.getConsoleStyle("green", "white"), this.utileService.getConsoleStyle(), `\n\t click_event \n\t view: ${environment.clientFolder + view} \n\t title: ${environment.clientFolder + title}`);
		if (!this.utileService.isDevMode()) {
			(<any>window).ga('send', {
				hitType: 'pageview',
				page: environment.clientFolder + view,
				title: environment.clientFolder + title
			});
		}
	}

	/* track events like links button clicks ... */
	trackEvent(category, action, label, value?) {
		var sendObj: any = {
			hitType: 'event',
			eventCategory: category,
			eventAction: action
		};

		if (label !== undefined) {//optional
			sendObj.eventLabel = label;
		}

		if (value !== undefined) {//optional
			sendObj.eventValue = value;
		}


		console.log(`%cGA FireBase trackEvent%c`, this.utileService.getConsoleStyle("blue", "white"), this.utileService.getConsoleStyle(), `\n\t click_event \n\t fbmParams: ${JSON.stringify(sendObj)}`);

		if (!this.utileService.isDevMode()) {
			(<any>window).ga('send', sendObj);
		}

	}



}



// WEBPACK FOOTER //
// ./src/app/services/analytics.service.ts